import { useTranslation } from "react-i18next";
import Dropdown from "./Dropdown";
import HotDropdown from "./HotDropdown";
import { useContext, useEffect } from "react";
import { DataContext } from "../utils/DataContext";
import { UserAuth } from "../utils/AuthContext";

export default function UserSection({ handleShowChart, page = "invoices" }) {
  const { t } = useTranslation("general");
  const { userData } = useContext(UserAuth);

  const {
    suppliers,
    setSuppliers,
    getFilteredSuppliers,
    selectedSupplier,
    getSuppliers,
    handleSelectSupplier,
    selectedSubCompany,
    subCompanies,
    handleSelectSubCompany,
    getSubCompanies,
    getFilteredSubCompanies,
    loading,
  } = useContext(DataContext);

  return (
    <>
      <div className="user-section">
        <div className="user">
          <span className="user-text">{`${t("user")}:`}</span>
          <span className="user-text">{`${localStorage.getItem(
            "username",
          )}`}</span>
        </div>
      </div>

      <div className="secondary-user-section">
        {userData?.userType === "user" ||
        userData?.userType === "indi" ? null : selectedSubCompany?.id ? (
          <section className="o-column-row-switcher_vertical-center u-margin--bottom_300 o-row--gap-size_100 u-width--max-width_700">
            <label className="u-min-width-specific_50">{t("company")}: </label>

            <Dropdown
              options={[{ id: "All", nameInAr: t("All") }, ...subCompanies]}
              selected={selectedSubCompany}
              setSelected={(subCompany) =>
                handleSelectSubCompany(subCompany, page)
              }
              nameInAr={true}
              getData={getFilteredSubCompanies}
              disabled={loading}
              prefetch={true}
              singleSelect={true}
              allowSameSelect={false}
              flex
            />
          </section>
        ) : (
          <section className="o-column-row-switcher_vertical-center u-margin--bottom_300 o-row--gap-size_100 u-width--max-width_700">
            <span>{t("noSubCompaniesFound")}</span>
          </section>
        )}

        {/* {selectedSupplier?.id ? ( */}
        <section className="o-column-row-switcher_vertical-center u-margin--bottom_300 o-row--gap-size_100 u-width--max-width_700">
          <label className="u-min-width-specific_50">{t("supplier")}: </label>
          <HotDropdown
            initOptions={
              page === "invoices" || page === "containerPrices"
                ? suppliers
                : [{ id: "All", name: t("All") }, ...suppliers]
            }
            setOptions={setSuppliers}
            selected={selectedSupplier}
            setSelected={handleSelectSupplier}
            page={page}
            getData={getFilteredSuppliers}
            optionsName={"suppliers"}
            disabled={loading}
            prefetch={true}
            allowSameSelect={false}
            flex
          />
        </section>
      </div>

      {/* ) : null} */}
    </>
  );
}
